import { render } from "./PlayerBox.vue?vue&type=template&id=f8b87040"
import script from "./PlayerBox.vue?vue&type=script&lang=js"
export * from "./PlayerBox.vue?vue&type=script&lang=js"
script.render = render

export default script